<div id="head"></div>
<h1 class="sr-only">macOS Dynamic Wallpaper Generator - Wallpapers That Change Through The Day</h1>

<!-- ===================== Hero: the wallpaper itself is the backdrop; the builder sits on it ===================== -->
<div class="default-section initial-section metallic-section no-buttons wp-hero" data-section="top"
     [class.cp-hero-noblur]="!!heroImage"
     [style.--hero-bg]="heroImage ? 'url(' + heroImage + ')' : null">
  <div class="cp-hero-head">
    <p class="tools-title" aria-hidden="true">{{ styleInfo.label }} Dynamic Wallpaper</p>
    <p class="tools-subtitle">Source: {{ sourceText }}</p>
  </div>
  <app-wallpaper-widget
    cardTitle="Dynamic Wallpaper"
    [palette]="palette"
    [subtitle]="subtitle"
    [scheme]="currentGenerator"
    [count]="count"
    (countChange)="count = $event"
    [style]="style"
    [seed]="artSeed"
    (editColor)="onEditColor( $event )"
    (reorder)="drop( $event )"
    (reverse)="reverseColors()"
    (addColor)="addColor()"
    (removeColor)="removeColor( $event )"
    (generate)="onGenerate( $event )"
    (uploadImage)="handleImageUpload( $event )"
    (styleChange)="onStyleChange( $event )"
    [params]="params"
    (paramsChange)="onParamsChange( $event )"
    [previewImage]="dayUrl"
    [dynamic]="dynamicSettings"
    [dynamicModes]="MODES"
    [frameCounts]="FRAME_COUNTS"
    [previewLoading]="framesLoading || building"
    (dynamicChange)="onDynamicChange( $event )"
    (heroRendered)="heroUrl = $event">
  </app-wallpaper-widget>
</div>

<nav class="cp-chipbar" appStuck aria-label="Dynamic wallpaper tool sections">
  <div class="cp-chipbar-row">
    <a *ngFor="let s of pageSections" class="pl-chip" [class.on]="activeSection === s.key" [attr.href]="'#sec-' + s.key"
       (click)="$event.preventDefault(); scrollToSection( s.key )">
      <span>{{ s.label }}</span>
    </a>
  </div>
</nav>

<div class="cp-body cp-boxes">
  <div class="cp-content">

    <!-- Preview: the wallpaper at any hour (the day's settings are in the widget above) -->
    <section class="cp-section" id="sec-preview" data-section="preview">
      <header class="cp-head">
        <span class="cp-eyebrow"><span class="cp-eyebrow-swatch wp-eyebrow-swatch" [style.background-image]="heroImage ? 'url(' + heroImage + ')' : null"></span>{{ sourceLabel }}</span>
        <h2 class="cp-h2">Preview</h2>
        <p class="cp-section-lead">{{ mode === 'appearance' ? 'The wallpaper in Light and in Dark mode. Switch between them' : 'The same wallpaper lit for every hour: your palette at noon, a warm glow at sunrise and sunset, a moonlit night. Drag the time or play the day' }}</p>
      </header>
      <div class="cp-main">

        <div class="wp-stage dw-stage">
          <span class="wp-stage-screen">
            <span class="dw-screen">
              <ng-container *ngIf="stage.from">
                <img class="dw-layer" [src]="stage.from" [alt]="styleInfo.label + ' dynamic wallpaper at ' + hourText" decoding="async">
                <img class="dw-layer dw-layer-top" *ngIf="stage.mix > 0" [src]="stage.to" [style.opacity]="stage.mix" alt="" aria-hidden="true" decoding="async">
                <span class="dw-clock">
                  <span class="dw-clock-time">{{ mode === 'appearance' ? ( isDark ? 'Dark' : 'Light' ) : hourText }}</span>
                  <span class="dw-clock-phase" *ngIf="mode !== 'appearance' && stage.frame">{{ stage.frame.phase }}</span>
                </span>
              </ng-container>
              <!-- while the day is drawn or the file is made: a soft shade and the Codigrate loader over the picture -->
              <span class="dw-loading" *ngIf="framesLoading || building">
                <app-codigrate-loader [scale]="1.62" [label]="building ? 'Making the wallpaper' : 'Drawing the wallpaper'"></app-codigrate-loader>
                <span class="dw-loading-text" *ngIf="building">Encoding frame {{ buildDone < buildTotal ? buildDone + 1 : buildTotal }} of {{ buildTotal }}</span>
              </span>
            </span>
          </span>

          <!-- the time: a slider through the day, or the Light / Dark switch -->
          <div class="dw-time" *ngIf="mode !== 'appearance'">
            <button type="button" class="cp-std-btn dw-play" (click)="togglePlay()" [attr.aria-label]="playing ? 'Pause the day' : 'Play the day'">
              <app-icon [name]="playing ? 'pause' : 'play'" aria-hidden="true"></app-icon>
            </button>
            <div class="dw-track">
              <input type="range" class="dw-range" min="0" max="23.99" step="0.05" [value]="hour"
                     (input)="setHour( $any( $event.target ).value )" (pointerdown)="playing && togglePlay()"
                     aria-label="Time of day" [attr.aria-valuetext]="hourText">
              <span class="dw-ticks" aria-hidden="true">
                <i *ngFor="let f of frames" [style.left.%]="f.hour / 24 * 100" [class.on]="stage.frame?.index === f.index"></i>
              </span>
              <span class="dw-hours" aria-hidden="true"><span>00:00</span><span>06:00</span><span>12:00</span><span>18:00</span><span>24:00</span></span>
            </div>
          </div>
          <div class="dw-switch" *ngIf="mode === 'appearance'" role="radiogroup" aria-label="Appearance">
            <button type="button" class="pl-chip" role="radio" [class.on]="!isDark" [attr.aria-checked]="!isDark" (click)="setAppearance( false )">
              <app-icon name="sun" aria-hidden="true"></app-icon><span>Light</span>
            </button>
            <button type="button" class="pl-chip" role="radio" [class.on]="isDark" [attr.aria-checked]="isDark" (click)="setAppearance( true )">
              <app-icon name="moon" aria-hidden="true"></app-icon><span>Dark</span>
            </button>
          </div>
        </div>

      </div>
    </section>

    <!-- Download: the size, then the .heic -->
    <section class="cp-section" id="sec-download" data-section="download">
      <header class="cp-head">
        <span class="cp-eyebrow"><span class="cp-eyebrow-swatch wp-eyebrow-swatch" [style.background-image]="heroImage ? 'url(' + heroImage + ')' : null"></span>{{ sourceLabel }}</span>
        <h2 class="cp-h2">Download</h2>
        <p class="cp-section-lead">One .heic file with all {{ frames.length }} frames and the {{ modeInfo.label | lowercase }} schedule, encoded in your browser at the size of your screen</p>
      </header>
      <div class="cp-main">
        <div class="wp-size-grid" role="radiogroup" aria-label="Wallpaper size">
          <button type="button" class="wp-size-card" *ngFor="let sz of SIZES" role="radio" [class.active]="sz.key === size.key" [attr.aria-checked]="sz.key === size.key"
                  (click)="selectSize( sz )" [attr.aria-label]="sz.label + ' for ' + sz.hint">
            <span class="wp-size-screen">
              <img *ngIf="sizeThumbs[ sz.key ]" class="wp-size-thumb" [src]="sizeThumbs[ sz.key ]" alt="" decoding="async">
              <span *ngIf="!sizeThumbs[ sz.key ]" class="wp-size-frame" [style.aspect-ratio]="sz.width + ' / ' + sz.height"></span>
            </span>
            <span class="wp-size-label">{{ sz.label }}</span>
            <span class="wp-size-hint">{{ sz.hint }}</span>
          </button>
        </div>

        <div class="dw-download">
          <button type="button" class="cp-std-btn wp-btn-primary dw-download-btn" (click)="download()" [disabled]="building || !frames.length || encoderSupported === false">
            <app-icon name="download" aria-hidden="true"></app-icon>
            {{ building ? 'Encoding frame ' + ( buildDone < buildTotal ? buildDone + 1 : buildTotal ) + ' of ' + buildTotal + '…' : 'Download .heic' }}
          </button>
          <button type="button" class="cp-std-btn dw-link-btn" (click)="copyLink()">
            <app-icon [name]="copied ? 'check' : 'link'" aria-hidden="true"></app-icon>{{ copied ? 'Copied' : 'Copy Link' }}
          </button>
          <span class="dw-download-meta">{{ size.label }} · {{ size.hint }} · {{ frames.length }} frames</span>
        </div>
        <div class="dw-progress" *ngIf="building" role="progressbar" aria-label="Encoding the wallpaper" [attr.aria-valuenow]="buildPercent" aria-valuemin="0" aria-valuemax="100">
          <span [style.width.%]="buildPercent"></span>
        </div>
        <p class="dw-error" *ngIf="buildError" role="alert">{{ buildError }}</p>
        <p class="dw-error-detail" *ngIf="buildErrorDetail">{{ buildErrorDetail }}</p>
        <!-- the file is coded by the browser's own HEVC encoder: without one there is no download -->
        <p class="dw-note" *ngIf="encoderSupported === false" role="status">This browser cannot encode HEIC pictures at {{ size.label }}.
          Open this page in Safari or Chrome on a Mac to download the wallpaper; the link keeps your palette, style and settings.</p>
      </div>
    </section>

    <!-- Frames: every picture in the file, at its hour -->
    <section class="cp-section" id="sec-frames" data-section="frames" *ngIf="frames.length">
      <header class="cp-head">
        <span class="cp-eyebrow"><span class="cp-eyebrow-swatch wp-eyebrow-swatch" [style.background-image]="heroImage ? 'url(' + heroImage + ')' : null"></span>{{ sourceLabel }}</span>
        <h2 class="cp-h2">Frames</h2>
        <p class="cp-section-lead">The {{ frames.length }} pictures in the file{{ mode === 'appearance' ? ', one for each appearance' : ', in the order of the day' }}. Pick one to see it on the stage</p>
      </header>
      <div class="cp-main">
        <div class="dw-frame-grid">
          <button type="button" class="wp-cv-pick dw-frame" *ngFor="let f of frames" (click)="mode === 'appearance' ? setAppearance( f.index === lightDark.dark ) : showFrame( f )"
                  [attr.aria-label]="'Show the ' + f.phase + ' frame' + ( mode === 'appearance' ? '' : ' at ' + f.label )">
            <span class="wp-cv-frame"><img *ngIf="f.url" [src]="f.url" [alt]="f.phase + ' frame'" decoding="async" loading="lazy"></span>
            <span class="dw-frame-cap">
              <span class="dw-frame-time" *ngIf="mode !== 'appearance'">{{ f.label }}</span>
              <span class="dw-frame-phase">{{ f.phase }}</span>
              <span class="dw-frame-tag" *ngIf="mode !== 'appearance' && f.index === lightDark.light">Light</span>
              <span class="dw-frame-tag" *ngIf="mode !== 'appearance' && f.index === lightDark.dark">Dark</span>
            </span>
            <span class="wp-cv-dots"><i *ngFor="let c of f.colors" [style.background]="c"></i></span>
          </button>
        </div>
      </div>
    </section>

    <!-- Set It Up: the file onto the desktop -->
    <section class="cp-section" id="sec-install" data-section="install">
      <header class="cp-head">
        <h2 class="cp-h2">Set It Up</h2>
        <p class="cp-section-lead">Three steps on any Mac since macOS Mojave</p>
      </header>
      <div class="cp-main">
        <ol class="dw-steps">
          <li><strong>Download the .heic</strong> at the size of your screen. Keep it somewhere it stays, like Pictures: macOS reads the file every time the picture changes.</li>
          <li><strong>Open System Settings, Wallpaper</strong> and click <em>Add Photo</em>, or drag the file onto the wallpaper list. You can also right click it in Finder and choose <em>Set Desktop Picture</em>.</li>
          <li><strong>Let it change.</strong> For a Time of Day or Sun Position file, choose <em>Dynamic</em> in the menu beside the picture: <em>Automatic</em> follows Light and Dark mode instead, so a Mac in Dark mode shows the night all day. Sun Position works the sun out from your location or your time zone; a Light &amp; Dark file follows System Settings, Appearance, with Automatic.</li>
        </ol>
      </div>
    </section>

    <!-- More Color Tools (owner 2026-10-22): the Color Picker, above How It Works -->
    <app-more-tools sectionKey="more" title="More Color Tools" lead="Pick any color on your screen and read it the same way, right from your menu bar"
                    [app]="colorPicker" [source]="moreToolsSource"></app-more-tools>

    <app-tool-about [lead]="aboutLead" [paragraphs]="aboutParagraphs" [faq]="faq" ratingKey="dynamic-wallpaper" ratingName="the Dynamic Wallpaper Generator"></app-tool-about>
  </div>
</div>
